export const reduceSumStats = (acc, item) => {
  const matchIndex = acc.findIndex(pItem => pItem.date === item.date)

  if (matchIndex > -1) {
    return [
      ...acc.slice(0, matchIndex),
      {
        ...item,
        clicks: +item.clicks + +acc[matchIndex].clicks,
        date: item.date,
        impressions: +item.impressions + +acc[matchIndex].impressions,
        queries: +item.queries + +acc[matchIndex].queries
      },
      ...acc.slice(matchIndex + 1)
    ]
  }

  return [...acc, { ...item }]
}

export default {
  reduceSumStats
}



// WEBPACK FOOTER //
// ./src/utils/stats/index.js